import {Component, ContentChild, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-guest-auth-main-layout',
  templateUrl: './guest-auth-main-layout.component.html',
  styleUrl: './guest-auth-main-layout.component.scss'
})
export class GuestAuthMainLayoutComponent {
  @ContentChild(TemplateRef, {static: true}) dynamicViewContent: TemplateRef<any>;

}
